import AddRoundedIcon from '@mui/icons-material/AddRounded';
import React from 'react';
import { useTranslation } from '@corti/i18n';
import { Base, Button } from 'lib/cortiUI';
export const Actions = ({ onCreateQuestion }) => {
    const { t } = useTranslation('templateBuilder', { keyPrefix: 'questions.actions' });
    return (React.createElement(Base, { width: "100%", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6, mb: 10 },
        React.createElement(Button, { startIcon: React.createElement(AddRoundedIcon, null), onClick: onCreateQuestion, variant: "contained", size: "small", color: "primary" }, t('add', 'Add question'))));
};
